import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getHotArticles, formatCount, getCategoryName } from '@/lib/content';
import type { Article } from '@/types/content';

interface CategorySidebarProps {
  activeSlug: string;
}

export default function CategorySidebar({ activeSlug }: CategorySidebarProps) {
  const hot = getHotArticles(5);

  return (
    <aside className="flex w-full flex-col gap-5 lg:w-72 lg:shrink-0">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
          <i className="ri-layout-grid-line text-primary-600" aria-hidden="true"></i>
          全部栏目
        </h2>
        <ul className="mt-4 flex flex-col gap-1">
          {categories.map((cat) => {
            const isActive = cat.slug === activeSlug;
            return (
              <li key={cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className={`flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <i className={cat.icon} aria-hidden="true"></i>
                    {cat.name}
                  </span>
                  <span className={`text-xs ${isActive ? 'text-background-100' : 'text-foreground-400'}`}>
                    {cat.count}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100/60 p-5">
        <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
          <i className="ri-fire-line text-accent-600" aria-hidden="true"></i>
          全站热读
        </h2>
        <ul className="mt-4 flex flex-col gap-4">
          {hot.map((item: Article, idx) => (
            <li key={item.id} className="flex gap-3">
              <span className="font-heading text-lg text-foreground-300">{idx + 1}</span>
              <div className="min-w-0">
                <Link
                  to={`/article/${item.id}`}
                  className="line-clamp-2 text-sm font-medium text-foreground-800 transition-colors hover:text-primary-700"
                >
                  {item.title}
                </Link>
                <p className="mt-1 text-xs text-foreground-500">
                  {getCategoryName(item.category)} · {formatCount(item.views)} 次围观
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}